<script>

import Search from '../field-types/Search.vue';

export default {
  name: 'TablaMaestraSearch',
  extends: Search,
  created() {
    if (
      this.params
      && this.params.istablaMaestraSearch === 'true'
      && this.initialValue !== ''
    ) {
      const initalVal = JSON.parse(this.initialValue);
      const initialAux = {
        item: Object.keys(initalVal.item)
          .filter((key) => !Number.isNaN(Number(key)))
          .map((key) => initalVal.item[key]),
      };
      const initial = initialAux.item;

      this.initialValue = initial;
      this.initializeFromTablaMaestra();
    }
  },
  methods: {
    initializeFromTablaMaestra() {
      let data = [];

      try {
        if (typeof this.initialValue === 'string') {
          try {
            data = JSON.parse(this.initialValue);
          } catch (error) {
            data = [];
            console.error(error);
          }
        } else if (Array.isArray(this.initialValue)) {
          data = this.initialValue;
        } else {
          data = [];
          console.error('initialValue no válido');
        }

        this.items = data.map((it, idx) => ({
          id: it.id || idx,
          name: it.name || it.texto || (`Item ${ (idx + 1) }`),
        }));

        this.initialValue = this.items;

        // Valor inicial vacío
        this.value = null;
        this.query = '';
        this.loading = false;
      } catch (error) {
        console.error(error);
      }
    },

    // Sobrescribir "refreshItems" para que no hacer llamadas, solo busqueda local
    async refreshItems(queryValue) {
      let initial = this.initialValue;
      if (!Array.isArray(this.initialValue)) {
        const initalVal = JSON.parse(this.initialValue);
        const initialAux = {
          item: Object.keys(initalVal.item)
            .filter((key) => !Number.isNaN(Number(key)))
            .map((key) => initalVal.item[key]),
        };
        initial = initialAux.item;
        this.initialValue = initial;
      }

      const search = (queryValue || '').toLowerCase();
      if (!search || search.length === 0) {
        this.items = initial;
        return;
      }

      const baseItems = this.initialValue;
      const filtered = baseItems.filter((item) => {
        const name = (item.name || item.texto || '').toLowerCase();
        const normalizedName = name.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
        const normalizedSearch = search.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');

        return normalizedName.includes(normalizedSearch);
      });

      this.items = filtered.map((it, idx) => ({
        id: it.id || idx,
        name: it.name || it.texto || (`Item ${ (idx + 1) }`),
      }));
    },

    // Ekiminar llamada a API
    async search() {
      return { list: this.items || [], total: (this.items || []).length };
    },
  },
};
</script>
